import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async createDashboardProfile(_, profileObject) {
    const response = await axios.post('/dashboards/profile', profileObject);
    return response.data.profile;
  },
  async getDashboardProfiles() {
    const response = await axios.get('/dashboards/profile');
    return response.data.profiles;
  },
  async getDashboardProfile(_, { profileId }) {
    const { data } = await axios.get(`/dashboards/profile/${profileId}`);
    return data;
  },
  async updateDashboardProfile(_, profileObject) {
    const response = await axios.patch(`/dashboards/profile/${profileObject._id}`, profileObject);
    return response.data.profile;
  },
  async deleteDashboardProfile(_, { profileId }) {
    const response = await axios.delete(`/dashboards/profile/${profileId}`);
    return response.data.profile;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/dashboards/dashboard-profiles.js